import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import {
    setLicensePlate,
    setWfSubscription,
    setContractNumber,
    setChoosedPropertyType,
    setSelectedSubscriptionOption
} from '../../../../../../../../redux/actions'
import { WebfleetSubscriptionsPage } from './wf-subscription-page'

const WebfleetSubscriptionsPageConnected = ({ activeStep, intl, setPagerFunctions, setStep, steps }) => {
    const dispatch = useDispatch()

    const mapDispatchToProps = {
        setChoosedPropertyType: propType => dispatch(setChoosedPropertyType(propType)),
        setContractNumber: contractNumber => dispatch(setContractNumber(contractNumber)),
        setLicensePlate: licensePlate => dispatch(setLicensePlate(licensePlate)),
        setPagerFunctions: funObj => setPagerFunctions(funObj),
        setSelectedSubscriptionOption: subscription => dispatch(setSelectedSubscriptionOption(subscription)),
        setWfSubscription: subscription => dispatch(setWfSubscription(subscription))
    }

    const mapStateToProps = {
        activationCode: useSelector(state => state.activationCode.activationCode) || '',
        activeStep,
        choosedPropertyType: useSelector(state => state.choosedPropertyType.choosedPropertyType),
        customerNumber: useSelector(state => state.customerNumber.customerNumber) || '',
        contractNumber: useSelector(state => state.contractNumber.contractNumber) || '',
        deviceSerialNumber: useSelector(state => state.deviceSerialNumber.deviceSerialNumber),
        intl,
        isGenerationRequired: useSelector(state => state.generationRequired.generationRequired),
        licensePlate: useSelector(state => state.licensePlate.licensePlate),
        rmaDevices: useSelector(state => state.rmaDevices.rmaDevices),
        setStep,
        steps,
        tankSize: useSelector(state => state.tankSize.tankSize),
        tariffs: useSelector(state => state.tariffs.tariffs),
        wfSubscription: useSelector(state => state.wfSubscription.wfSubscription)
    }

    return (
        <WebfleetSubscriptionsPage
            {...{
                ...mapStateToProps,
                ...mapDispatchToProps
            }}
        />
    )
}

WebfleetSubscriptionsPageConnected.propTypes = {
    activeStep: PropTypes.number,
    intl: PropTypes.objectOf(PropTypes.func),
    setPagerFunctions: PropTypes.func,
    setStep: PropTypes.func,
    steps: PropTypes.array
}

export { WebfleetSubscriptionsPageConnected }
